exports.components = {
  "component---src-containers-establishment-tsx": () => import("./../../../src/containers/establishment.tsx" /* webpackChunkName: "component---src-containers-establishment-tsx" */)
}

